import React from 'react';
import Grid from '@mui/material/Grid';
import AutoSelect from '../../../containers/selects/auto_select';

const AutoSelectProduct = (props) => {

    return(
        <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
                <input hidden id='order_product' />
                <input hidden id='order_product_ref' />
                <AutoSelect
                    id='order_product_autoselect'
                    label='Producto'
                    getOptionLabel={(option) => `${option.product ? option.product.ref : ''}`}
                    renderOption={(props, option) => {
                        if(option.product){
                            return(<div {...props}>{`${option.product?.ref}`}</div>);
                        }
                    }}
                    data={props.products}
                    onChange = {(value) => {
                        document.getElementById('order_product').value = value ? value['uuid'] : '';
                        document.getElementById('order_product_ref').value = value ? value.product ? value.product['ref'] : '' : '';
                        props.onChange(value);
                    }}
                />
            </Grid>
        </Grid>
    );

}

export default AutoSelectProduct;